<template>
    <div  id="partiOra" class="prossimi-tour px-3 py-md-2" v-if="list.length>0">
        <div class="pb-2 mb-5">
            <h2>{{title}}</h2>
            <div class="pb-3" v-if="resultMessage">
                    <span class="text-primary">{{resultMessage}}</span>
            </div>
            <h5 class="text-primary text-uppercase mb-0">{{subtitle}}</h5>
        </div>
        <div class="mt-2">
            <carousel :per-page=1 navigation-enabled :pagination-enabled=false navigation-next-label="<div></div>" navigation-prev-label="<div></div>">
                <slide v-for="(item, index) in list" :key="index">
                    <VerticalItemTourMobile :value="item" @select="onOpenDetail"/>
                </slide>
            </carousel>
        </div>
        <ModalTourDetail v-if="tourSelected" :is-home-page="true" :value="tourSelected" ref="modalTourDetail" @select="onSelect" :is-camere-requested="true"/>
    </div>
</template>

<script>
import ProssimiTourDesktop from '../../../../widgets/pages/home/ProssimiTour'
import VerticalItemTourMobile from '../../common/tours/VerticalItemTour'

export default {
  name: 'ProssimiTour',
  mixins: [ProssimiTourDesktop],
  components: {VerticalItemTourMobile}
}

</script>



// WEBPACK FOOTER //
// src/front/components/mobile/widgets/pages/home/ProssimiTour.vue